import { useState, useCallback } from 'react';
const NAVIGATION_SELECTOR = 'data-item-keyboard-navigation';
const mod = (index, length) => (Math.abs(index * length) + index) % length;
export default function useKeyboardNavigation(wrapper) {
  let handler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : item => item === null || item === void 0 ? void 0 : item.focus();
  const [activeIndex, setActiveIndex] = useState(-1);
  const handleKeyboardNavigation = useCallback(_ref => {
    var _ArrowDown$ArrowUp$ke, _ArrowDown$ArrowUp;
    let {
      key
    } = _ref;
    if (!wrapper) return;
    const items = Array.from(wrapper.querySelectorAll("*[".concat(NAVIGATION_SELECTOR, "]:not([disabled])")));
    if (!items.length) return;
    const indexToBeActivated = (_ArrowDown$ArrowUp$ke = (_ArrowDown$ArrowUp = {
      ArrowDown() {
        if (activeIndex === -1) return 0;
        return mod(activeIndex + 1, items.length);
      },
      ArrowUp() {
        if (activeIndex === -1) return items.length - 1;
        return mod(activeIndex - 1, items.length);
      }
    })[key]) === null || _ArrowDown$ArrowUp$ke === void 0 ? void 0 : _ArrowDown$ArrowUp$ke.call(_ArrowDown$ArrowUp);
    if (indexToBeActivated == null) return;
    setActiveIndex(indexToBeActivated);
    handler(items[indexToBeActivated], items);
  }, [wrapper, activeIndex, handler]);
  const clearActiveIndex = useCallback(() => setActiveIndex(-1), []);
  return {
    handleKeyboardNavigation,
    keyboardNavigationProps: {
      [NAVIGATION_SELECTOR]: true
    },
    activeIndex,
    clearActiveIndex
  };
}